export const REGULATION_CATEGORIES = [
  { id: "job", label: "Должностные инструкции" },
  { id: "accounting", label: "Бухгалтерские задачи" },
  { id: "technical", label: "Технические инструкции" },
  { id: "other", label: "Прочие правила" },
  { id: "fk", label: "Задачи в ФК" },
];

export function categoryLabel(id) {
  return REGULATION_CATEGORIES.find((item) => item.id === id)?.label || id;
}

export function isRegulationCategory(value) {
  return REGULATION_CATEGORIES.some((item) => item.id === value);
}
